module.exports = __webpack_public_path__ + "img/call.cfcbc30f.png";